import { useEffect, useRef } from 'react';

export const useIdleTimer = (onIdle: () => void, timeout: number) => {
  const timer = useRef<number | undefined>(undefined);

  const resetTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = window.setTimeout(onIdle, timeout);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];

    const eventHandler = () => resetTimer();

    events.forEach((event) => {
      window.addEventListener(event, eventHandler);
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, eventHandler);
      });
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, [timeout, onIdle]);

  return;
};
